import EditorSection from 'gui/components/editors/commons/editor/components/editorSection/EditorSection';
import React from 'react';
import styles from "./PreparedTopEditorSection.module.scss";


interface IPreparedTopEditorSectionProps {
  title?: string;
  children?: any;
}

const PreparedTopEditorSection = props => (<EditorSection title={props.title}
                                                          titleClassName={styles.editorSectionTitle}>
  {props.children}
</EditorSection>);

PreparedTopEditorSection.defaultProps = {
  title: 'תחת איזה קטגוריה להציג את השובר באתר?',
};

export default PreparedTopEditorSection;
